
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.7143 21.4286V23H4V21.4286H19.7143ZM11.8571 1C16.1896 1 19.7143 4.52471 19.7143 8.85714C19.7136 10.3063 19.309 11.7266 18.5459 12.9586C18.3102 13.3414 18.0448 13.7031 17.7502 14.0388L17.5237 14.2856L12.4213 19.3881C12.2783 19.5366 12.0795 19.6309 11.8571 19.6309C11.7516 19.6306 11.6472 19.609 11.5502 19.5672C11.4855 19.5394 11.4251 19.5031 11.3704 19.4593L11.293 19.3881L6.19057 14.2856C5.804 13.8826 5.463 13.4371 5.16836 12.9586C4.43214 11.7627 4 10.361 4 8.85714C4 4.52471 7.52471 1 11.8571 1ZM11.8571 5.71429C10.1239 5.71429 8.71428 7.12386 8.71428 8.85714C8.71428 10.5904 10.1239 12 11.8571 12C13.5904 12 15 10.5904 15 8.85714C15 7.12386 13.5904 5.71429 11.8571 5.71429Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'RegionFilled',
    }) as DefineComponent
    </script>
    